<template>
  <div class="form-material mt-3 container-fluid">
    <div class="row px-2">
      <div class="form-group col-lg-2 col-4">
        <div class="form-group form-default">
          <input v-model="name" class="form-control" type="text"/>
          <span class="form-bar">
          </span>
          <label class="float-label ml-1" :class="{'fill': name}">Code</label>
        </div>
      </div>
      <div class="form-group col-lg-1 col-4">
        <div class="form-group form-default">
          <input v-model="id" class="form-control" type="text"/>
          <span class="form-bar">
          </span>
          <label class="float-label ml-1" :class="{'fill': id}">ID</label>
        </div>
      </div>
      <div class="form-group col-lg-1 col-4">
        <div class="form-group form-default">
          <input v-model="reference" class="form-control" type="text"/>
          <span class="form-bar">
          </span>
          <label class="float-label ml-1" :class="{'fill': reference}">Reference</label>
        </div>
      </div>
      <div class="form-group col-lg-1 col-12 d-flex justify-content-center d-md-block mt-0 mt-md-4">
        <button type="button" class="btn btn-primary my-0" @click="find()" :disabled="processing">Find</button>
      </div>
      <div class="form-group col-lg-4 col-12 d-flex justify-content-center d-md-block mt-0 mt-md-4">
        <span v-for="(location, id) of locations" :class="{'fw-bold': url==id}" 
          :key="id" class="ml-1 cursor-pointer" @click="url=id"> 
          &nbsp; &nbsp;{{id}}
        </span>
      </div>
      <div class="form-group col-lg-2 col-12 d-flex justify-content-center d-md-block mt-0 mt-md-4">
        <span :class="{'fw-bold': language=='EN'}" class="ml-1 cursor-pointer" @click="language='EN'"> 
          &nbsp; &nbsp;EN
        </span>
        <span :class="{'fw-bold': language=='SP'}" class="ml-1 cursor-pointer" @click="language='SP'"> 
          &nbsp; &nbsp;ES
        </span>
        <span :class="{'fw-bold': language=='DE'}" class="ml-1 cursor-pointer" @click="language='DE'"> 
          &nbsp; &nbsp;DE
        </span>
      </div>

    </div>
    <div class="d-flex w-100 justify-content-md-end justify-content-center mb-3">
      <search-box class="col-md-3 col-12" v-model="search" :material="true"></search-box>
    </div>
    <div class="row" v-if="filteredFITs.length > 0">
    <table class="table table-striped table-sm table-bordered responsive-stack d-flex d-md-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>ID</th>
          <th>Reference</th>
          <th>Name Alias</th>
          <th>Usuario</th>
          <th>Status</th>
          <th>Date</th>
          <th>URL</th>
        </tr>
      </thead>
      <tbody class="w-100">
        <tr v-for="(fit, index) of filteredFITs" :key="'S-' + index">
          <td data-label="Name">{{ fit.NAME }}</td>
          <td data-label="ID">{{ fit.bhd_ID }}</td>
          <td data-label="Reference">{{ fit.REFERENCE }}</td>
          <td data-label="Name Alias">{{ fit.NAME_ALIAS }}</td>
          <td data-label="Usuario">{{ fit.INIT }}</td>
          <td data-label="Status">{{ fit.Status }}</td>
          <td data-label="Date">{{ toDateTime(fit.DATE_ENTERED) }}</td>
          <td class="text-left">
              <!-- Cambio aquí con clases de Bootstrap -->
              <a :href="getURL(fit)" target="_blank" class="text-truncate d-inline-block mw-100 me-4">{{ getURL(fit) }}</a>
              <Transition mode="out-in">
                <a class="cursor-pointer" @click="copyURL(fit, index)" v-if="!copied[index]">Copy</a>
                <span v-else>✓ <i class="ml-1">Copied!</i></span>
              </Transition>
            </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
</template>

<script>
var moment = require('moment');
import SearchBox from "@/components/tools/SearchBox.vue";
const api = window.api;
const localUrl = window.location.origin;
var locations = {
  sayhueque: 'https://yourtrip.sayhueque.com',
  saysouthamerica: 'https://yourtrip.saysouthamerica.com',
  yourtrip: 'https://yourtrip.sayyourtrip.com',
  testing: 'https://test-itinerario.sayhueque.com'
}
var defLocation = 'sayhueque';
if (process.env.NODE_ENV == 'development') {
  locations.local = localUrl;
  defLocation = 'local';
}

export default {
  name: 'SayFIT',
  components: {
    SearchBox,
  },
  data () {
    return {
      name: '',
      id: null,
      reference: null,
      fits: [],
      url: defLocation,
      language: 'EN',
      processing: false,
      copied: {},
      locations: locations,
      search: ''
    }
  },
  computed: {
    filteredFITs() {
      if (!this.fits || !Array.isArray(this.fits)) {
        return [];
      }
      if (!this.search) return this.fits;
      
      const searchLower = this.search?.toLowerCase();
      return this.fits.filter((fit) => {
        return (
          fit.bhd_ID?.toString().toLowerCase().includes(searchLower) ||
          fit.NAME?.toLowerCase().includes(searchLower) ||
          fit.REFERENCE?.toLowerCase().includes(searchLower) ||
          fit.NAME_ALIAS?.toLowerCase().includes(searchLower) ||
          fit.INIT?.toLowerCase().includes(searchLower)
        );
      });
    },
  },
  props: {
  },
  methods: {
    async find () {
      this.processing = true;
      this.$store.commit('setProcessing', true);
      let filters = {}
      if (this.name) filters.name = this.name;
      if (this.id) filters.id = this.id;
      if (this.reference) filters.reference = this.reference;
      let res = await api.get('/api/tpsql/find_fit', filters, 
        (err) => { console.log(err), this.processing = false});
      this.processing = false;
      if (res) {
        this.fits = res;
      }
      this.$store.commit('setProcessing', false);
      return res;
    },
    toDateTime (d) {
      return moment(d).format('DD MMM YYYY');
    },
    getURL (fit) {
      let url = this.locations[this.url];
      if (this.url == 'local') {
        url = url.replace('8081', '8082');
      }
      return `${url}/fit?ID=${fit.bhd_ID}&Code=${fit.REFERENCE}&Lang=${this.language}`
    },
    copyURL (fit, index) {
      navigator.clipboard.writeText(this.getURL(fit));
      this.copied[index] = true;
      this.copied = Object.assign({}, this.copied);
      setTimeout(() => {
        this.copied[index] = false;
        this.copied = Object.assign({}, this.copied);
      }, 5000)
    }
  },
}
</script>

<style scoped>
.text-right {
  text-align: right !important;
}
.text-left {
  text-align: left !important;
}
.bold {
  font-weight: bold !important;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
@media (max-width: 767.98px) {
  .responsive-stack {
    display: block;
  }
  .responsive-stack thead {
    display: none; /* Oculta el encabezado en mobile */
  }
  .responsive-stack tr {
    display: block;
    margin-bottom: 1rem;
  }
  .responsive-stack td {
    display: block;
    text-align: left !important;
    position: relative;
    padding-left: 50%;
  }
  .responsive-stack td::before {
    content: attr(data-label);
    position: absolute;
    left: 0.5rem;
    width: 45%;
    font-weight: bold;
  }
}
</style>
